// Small localStorage-backed cache + lock so multiple open tabs of the app
// share one fetch instead of each tab independently polling the same
// endpoint. Read with readCache(); if it's null (missing/expired), try
// tryAcquireLock() before fetching — if another tab already holds the
// lock, skip the fetch and rely on the `storage` event (fires in every
// *other* tab when localStorage changes) to pick up its result once it
// calls writeCache(). Always releaseLock() in a finally block.
const LOCK_TTL_MS = 5000;

export function readCache(key, ttlMs) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.fetchedAt !== "number") return null;
    if (Date.now() - parsed.fetchedAt > ttlMs) return null;
    return parsed.value;
  } catch {
    return null;
  }
}

export function writeCache(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify({ value, fetchedAt: Date.now() }));
  } catch {
    // localStorage can throw (private browsing, quota) — cross-tab sharing
    // is best-effort, each tab still falls back to fetching for itself.
  }
}

export function tryAcquireLock(lockKey, lockTtlMs = LOCK_TTL_MS) {
  try {
    const raw = localStorage.getItem(lockKey);
    if (raw) {
      const lockedAt = Number(raw);
      if (Number.isFinite(lockedAt) && Date.now() - lockedAt < lockTtlMs) {
        return false;
      }
    }
    localStorage.setItem(lockKey, String(Date.now()));
    return true;
  } catch {
    return true;
  }
}

export function releaseLock(lockKey) {
  try {
    localStorage.removeItem(lockKey);
  } catch {
    // best-effort
  }
}
